<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function() {
    // Object mapping IDs to collection URLs
    const collectionMap = {
      'block-featured_collection_dFGYEw': '/collections/saanjh-savera',
      'block-featured_collection_T4RXh4': '/collections/floral-panache',
      'block-featured_collection_yKYUJR': '/collections/manchali-heer',
      'block-featured_collection_xBeyQb': '/collections/the-banjaran',
      'halo-image-banner-template--19323865268462__image_banner_qAGcmA':'/pages/contact',
      'halo-image-banner-template--19323865268462__image_banner_7jCEcY':'/pages/contact'
    };

    // Loop through each ID and attach click handler
    $.each(collectionMap, function(id, url) {
      $('#' + id).on('click', function(event) {
        event.preventDefault(); // Prevent default behavior of disabled <a> tags
        window.location.href = url;
      });
    });
  });